import React, { useState, useEffect, useCallback } from 'react';
import { Tabs } from '@b-design/fusion';
import $i18n from '@/i18n';
import Spaces from './component/spaces';
import Invitations from './component/invitationsRecord';
import './index.less';
import Header from './component/header';
import Requests from '@/services/request';
import CalculateComponent from '@/components/CalculateComponent';
import { getQueryStringArgs } from '@/utils/url-parse';

const Invitation: React.FC = () => {
  // 内容区域高度
  const [contentHeight, setContentHeight] = useState(200);

  const { spaceId } = getQueryStringArgs();
  const [dataSource, setDataSource] = useState({ list: [], total: 0 });
  const [loading, setLoading] = useState(false);
  // 分页参数
  const [paginationValue, setPaginationValue] = useState<
    Record<'currentPage' | 'pageSize', number>
  >({
    currentPage: 1,
    pageSize: 10,
  });

  const queryInvitations = useCallback(
    (params = { spaceId, currentPage: 1, pageSize: 10, type: 'SPACE_CREATE' }) => {
      if (!spaceId) {
        return;
      }
      setLoading(true);
      Requests.get('/rest/intercnn/invitation/query', { ...params }).then((data) => {
        if (data) {
          const { list = [], total } = data;
          const newList = list?.map(item => ({ ...item, extInfo: { ...item?.extInfo, roleList: item?.extInfo?.role?.split(',') || [] } }))
          setDataSource({ list: newList, total });
          setLoading(false);
        }
      });
    },
    [spaceId],
  );

  return (
    <div className="global-filter-list">
      <Header queryInvitations={queryInvitations} setPaginationValue={setPaginationValue} />
      <div className="detail-container">
        <Tabs shape="wrapped">
          <Tabs.Item
            title={$i18n.get({ id: 'aopf.pages.invitation.tabSpaces', dm: '空间' })}
            key={'Spaces'}
          >
            <Spaces contentHeight={contentHeight} />
          </Tabs.Item>
          <Tabs.Item
            title={$i18n.get({ id: 'aopf.pages.invitation.tabInvitations', dm: '邀请记录' })}
            key={'Invitations'}
          >
            <Invitations
              queryInvitations={queryInvitations}
              dataSource={dataSource}
              loading={loading}
              paginationValue={paginationValue}
              setPaginationValue={setPaginationValue}
              contentHeight={contentHeight}
            />
          </Tabs.Item>
        </Tabs>
        <CalculateComponent
          otherWidth={280}
          otherHeight={88 + 48 + 56 + 56}
          windowChange={(_width, height) => {
            setContentHeight(height);
          }}
        />
      </div>
    </div>
  );
};
export default Invitation;
